var App = (function () {
  'use strict';

  App.payment = function( ){
    var formSelector = '.js-payment-form',
        linkSelector = '.js-payment-link',
        copySelector = '.js-copy-button';

    var $form = $(formSelector),
        $link = $(linkSelector),
        $copy = $(copySelector),
        $inputs = $form.find('input, select, textarea');

    function change() {
      var url = $form.prop('action'),
        query = $form.serialize(),
        sum = $form.find('input[name="sum"]').val();

      var link = url + '?' + query;
      if (sum === '' || isNaN(parseInt(sum))) {
        link = ''
      }

      $link.val(link);
      $copy.data('copy', link);
      if (link) {
        $link.prop('disabled', false);
        $copy.prop('disabled', false);
      } else {
        $link.prop('disabled', true);
        $copy.prop('disabled', true);
      }
    }


    if ($form.length) {
      $inputs.on('change', function(e) {
        change();
      });
      change();
    }
  };

  return App;
})(App || {});
